import axios from "axios";

const axiosWithOutToken = axios.create();

axiosWithOutToken.interceptors.response.use(async (config) => {
    return config;
}, function (error) {
    return Promise.reject(error);
});

axiosWithOutToken.interceptors.request.use(async (config) => {
    return config;
}, function (error) {
    return Promise.reject(error);
});

export default axiosWithOutToken;
